import React from 'react';
import {
  READINESS_READY_CUBE_BORDER,
  READINESS_READY_CUBE_GRADIENT,
  READINESS_READY_CUBE_TEXT,
} from '../../lib/checklistBrandColors';
import { buildDiscussTaskUrl } from '../../lib/discussTaskLinks';

const ASSETS = {
  logo: '/images/checklist-result/logo.png',
  cubesGroup: '/images/checklist-result/cubes-group.png',
};

/** Ширина контейнера письма (preview; для HTML-email позже). */
export const CHECKLIST_SALES_EMAIL_WIDTH = 800;

const HEADER_GRADIENT = [
  'radial-gradient(ellipse 85% 55% at 18% 88%, rgba(255, 191, 42, 0.95) 0%, transparent 55%)',
  'radial-gradient(ellipse 75% 50% at 82% 12%, rgba(234, 56, 14, 0.85) 0%, transparent 50%)',
  'linear-gradient(90deg, #EA380E 0%, #F08517 42%, #FFBF2A 100%)',
].join(', ');

const CTA_GRADIENT = [
  'radial-gradient(ellipse 85% 55% at 18% 88%, rgba(255, 191, 42, 0.95) 0%, transparent 55%)',
  'radial-gradient(ellipse 75% 50% at 82% 12%, rgba(234, 56, 14, 0.85) 0%, transparent 50%)',
  'linear-gradient(90deg, #EA380E 0%, #F08517 42%, #FFBF2A 100%)',
].join(', ');

/** Макет Figma node 2332:6 — статичные данные для вёрстки письма (без API). */
export const CHECKLIST_SALES_EMAIL_MOCK = {
  eyebrow: 'Чек-лист',
  title: 'Готовность отдела продаж к Generative AI',
  score: 162,
  maxScore: 230,
  readinessLabel: 'Частично готовы',
  readinessEmoji: '⚠️',
  user: {
    name: 'Сергей Успенский',
    company: 'ООО «УСПЕНСКИЙ ТЕХНОЛОГИИ»',
    email: 'sergey@example.com',
  },
  blocks: [
    {
      id: 'processes',
      title: 'Процессы',
      description:
        'Насколько отлажены процессы создания продающих материалов и есть ли готовые шаблоны',
      score: 20,
      maxScore: 40,
      questions: [
        { text: 'Есть ли в отделе продаж утверждённые шаблоны коммерческих предложений?', score: 5, maxScore: 10 },
        { text: 'Используют ли менеджеры типовые шаблоны писем для первичного и повторного контакта?', score: 5, maxScore: 10 },
        { text: 'Есть ли документированные скрипты или сценарии разговора с клиентом?', score: 10, maxScore: 10 },
        { text: 'Есть ли процесс согласования материалов перед отправкой клиенту?', score: 0, maxScore: 10 },
      ],
    },
    {
      id: 'team',
      title: 'Команда',
      description: 'Насколько команда открыта к новым технологиям и есть ли базовые навыки',
      score: 32,
      maxScore: 50,
      questions: [
        { text: 'Менеджеры умеют работать в CRM и заносить данные о клиентах?', score: 7, maxScore: 10 },
        { text: 'Есть ли в команде 1-2 человека, которые любят новые технологии?', score: 10, maxScore: 10 },
        { text: 'Готовы ли сотрудники потратить 2-3 часа на обучение работе с ИИ?', score: 5, maxScore: 10 },
        { text: 'Есть ли в команде человек, который может стать администратором ИИ-инструментов?', score: 0, maxScore: 10 },
        { text: 'Обсуждали ли в команде возможности ИИ для продаж?', score: 10, maxScore: 10 },
      ],
    },
    {
      id: 'tools',
      title: 'Инструменты',
      description: 'Техническая готовность: CRM, почта, доступ к сервисам',
      score: 30,
      maxScore: 30,
      questions: [
        { text: 'Используется ли CRM-система (amoCRM, Битрикс24, другое)?', score: 10, maxScore: 10 },
        { text: 'Есть ли корпоративная почта или мессенджер для рабочих переписок?', score: 10, maxScore: 10 },
        { text: 'Возможно ли установить браузерные расширения или дополнительные программы?', score: 10, maxScore: 10 },
      ],
    },
    {
      id: 'content',
      title: 'Контент',
      description: 'Объём и регулярность создания продающего контента',
      score: 30,
      maxScore: 60,
      questions: [
        { text: 'Сколько писем в месяц отправляет отдел? (шкала: 1 ≈ 10 писем, 10 ≈ 100)', score: 5, maxScore: 10 },
        { text: 'Сколько КП в месяц готовите? (шкала: 1 ≈ 10 КП, 10 ≈ 100)', score: 5, maxScore: 10 },
        { text: 'Делаете ли презентации или рекламные материалы (картинки, баннеры)?', score: 10, maxScore: 10 },
        { text: 'Снимаете ли видео для клиентов (демо, ответы на вопросы)?', score: 0, maxScore: 10 },
        { text: 'Есть ли потребность в персонализированных материалах для VIP-клиентов?', score: 10, maxScore: 10 },
        { text: 'Создаёте ли контент для соцсетей (посты, статьи)?', score: 0, maxScore: 10 },
      ],
    },
    {
      id: 'budget',
      title: 'Бюджет',
      description: 'Готовность инвестировать в инструменты и обучение',
      score: 50,
      maxScore: 50,
      questions: [
        { text: 'Есть ли в бюджете статья на инструменты для отдела продаж?', score: 10, maxScore: 10 },
        { text: 'Рассматривали ли бюджет на обучение команды (хотя бы 10-20 тыс. ₽)?', score: 10, maxScore: 10 },
        { text: 'Есть ли понимание, что ИИ — инструмент, а не волшебная таблетка?', score: 10, maxScore: 10 },
        { text: 'Готовы ли выделить время сотрудников на тестирование (1-2 недели)?', score: 10, maxScore: 10 },
        { text: 'Есть ли поддержка руководителя в экспериментах с новыми инструментами?', score: 10, maxScore: 10 },
      ],
    },
  ],
  pilot: {
    title: 'С чего начать пилот',
    solutionType: 'Агент',
    summary: 'Целевой уровень по задачам: Harness.',
    bullets: [
      'Система сама планирует шаги и вызывает инструменты. Высокий потенциал и риск — нужны владелец процесса и обвязка.',
      'Вы отметили: много ручных КП, писем и материалов — с проверкой и одобрением сотрудником.',
      'По задачам это уровень «Harness», но при текущей готовности (162 из 230) разумнее начать пилот с «Агент» и сузить контур.',
      'Harness оправдан, когда есть поток задач в проде и обвязка (лимиты, логи, human-in-the-loop) — не как первый шаг пилота.',
    ],
    linkLabel: 'Подробнее: классификация ИИ-решений →',
    linkHref: 'https://antologia.tech/blog/klassifikaciya-ii-reshenij-chat-rag-agent-harness',
  },
  readinessScale: [
    { id: 'not-ready', emoji: '❌', label: 'Не готовы', range: '0-100', active: false },
    { id: 'partial', emoji: '⚠️', label: 'Частично готовы', range: '101-200', active: true },
    { id: 'ready', emoji: '✅', label: 'Можно внедрять', range: '201-230', active: false },
  ],
  cta: {
    title: 'Готовы к следующему шагу?',
    subtitle: 'Обсудим стратегию внедрения AI в ваш бизнес',
    buttonLabel: 'Обсудить внедрение AI',
  },
};

function QuestionDot({ score }) {
  const isZero = score === 0;
  return (
    <span
      className={`mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
        isZero ? 'bg-[#f3f4f6]' : 'bg-[#fef3c6]'
      }`}
      aria-hidden
    >
      <span className={`h-2 w-2 rounded-full ${isZero ? 'bg-[#99a1af]' : 'bg-[#e17100]'}`} />
    </span>
  );
}

function BlockProgressBar({ score, maxScore }) {
  const percent = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0;
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-[#f3f4f6]">
      <div
        className="h-full rounded-full bg-gradient-to-r from-[#ec5511] to-[#ffbe2b]"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}

function BlockCard({ block }) {
  return (
    <article className="overflow-hidden rounded-[14px] border border-[#e5e7eb] bg-white">
      <header className="border-b border-[#f3f4f6] bg-[#1a1a1a] px-8 py-5">
        <div className="flex items-center justify-between gap-4">
          <h3 className="font-even-mono text-xl text-white">{block.title}</h3>
          <p className="font-even-mono shrink-0 text-2xl text-white">
            {block.score}
            <span className="text-base text-[#99a1af]">/{block.maxScore}</span>
          </p>
        </div>
        <p className="mt-2 text-sm leading-5 text-[#99a1af]">{block.description}</p>
      </header>

      <div className="px-8 pt-5">
        <BlockProgressBar score={block.score} maxScore={block.maxScore} />
      </div>

      <ul className="flex flex-col gap-4 px-8 py-8">
        {block.questions.map((q) => (
          <li key={q.text} className="flex gap-4">
            <QuestionDot score={q.score} />
            <div className="min-w-0 flex-1">
              <p className="text-base leading-6 text-[#364153]">{q.text}</p>
              <p className="mt-1.5 text-sm text-[#99a1af]">
                {q.score} / {q.maxScore} баллов
              </p>
            </div>
          </li>
        ))}
      </ul>
    </article>
  );
}

function ReadinessScaleRow({ item }) {
  if (item.active) {
    const isReady = item.id === 'ready';
    return (
      <div
        className="relative flex min-h-[76px] items-center rounded-[10px] px-6 py-4 shadow-sm"
        style={
          isReady
            ? {
                backgroundImage: READINESS_READY_CUBE_GRADIENT,
                border: `1px solid ${READINESS_READY_CUBE_BORDER}`,
              }
            : {
                background: '#ec5811',
                border: '1px solid rgba(236, 88, 17, 0.2)',
              }
        }
      >
        <span className="text-2xl" aria-hidden>
          {item.emoji}
        </span>
        <div className="ml-4">
          <p
            className="text-base"
            style={{ color: isReady ? READINESS_READY_CUBE_TEXT : '#ffffff' }}
          >
            {item.label}
          </p>
          <p
            className="text-sm"
            style={{ color: 'rgba(255, 255, 255, 0.6)' }}
          >
            {item.range}
          </p>
        </div>
        <span
          className="absolute right-6 top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full"
          style={{ background: '#ffffff' }}
          aria-hidden
        />
      </div>
    );
  }

  return (
    <div className="flex min-h-[76px] items-center rounded-[10px] border border-[#e5e7eb] bg-white px-6 py-4">
      <span className="text-2xl" aria-hidden>
        {item.emoji}
      </span>
      <div className="ml-4">
        <p className="text-base text-[#101828]">{item.label}</p>
        <p className="text-sm text-[#6a7282]">{item.range}</p>
      </div>
    </div>
  );
}

/**
 * Вёрстка email-отчёта sales-чек-листа (Figma 2332:6).
 * Preview в браузере. Для отправки письма — checklistSalesEmailTemplate.js (inline-стили).
 */
const ChecklistSalesEmail = ({ data = CHECKLIST_SALES_EMAIL_MOCK }) => {
  const d = data;

  return (
    <div
      className="mx-auto w-full max-w-[800px] overflow-hidden bg-white shadow-[0px_10px_7.5px_rgba(0,0,0,0.1),0px_4px_3px_rgba(0,0,0,0.1)]"
      data-testid="checklist-sales-email"
    >
      {/* Header */}
      <header
        className="relative flex min-h-[310px] flex-col items-center justify-center px-10 py-12 text-center text-white"
        style={{ background: HEADER_GRADIENT }}
      >
        <p className="text-base tracking-[-0.15px]">{d.eyebrow}</p>
        <h1 className="font-even-mono mt-4 max-w-[640px] text-3xl leading-9 tracking-[-0.53px]">
          {d.title}
        </h1>
        <p className="font-even-mono mt-8 flex items-baseline justify-center gap-2 tabular-nums">
          <span className="text-[72px] leading-none">{d.score}</span>
          <span className="text-[36px] text-white/40">/</span>
          <span className="text-[36px] text-white/40">{d.maxScore}</span>
        </p>
        <div className="mt-8 inline-flex h-10 items-center gap-2 rounded-lg border border-[#E3AF20]/30 bg-white/20 px-5">
          <span className="text-base" aria-hidden>
            {d.readinessEmoji}
          </span>
          <span className="text-base font-medium tracking-[-0.15px]">{d.readinessLabel}</span>
        </div>
      </header>

      {/* User info */}
      <section className="border-b border-[#1a1a1a]/20 bg-[#ECEBF2] px-10 py-7">
        <dl className="space-y-5">
          {[
            ['Имя', d.user.name],
            ['Компания', d.user.company],
            ['Почта', d.user.email],
          ].map(([label, value]) => (
            <div key={label} className="flex items-center justify-between gap-4 text-base">
              <dt className="font-even-mono text-lg text-[#1a1a1a]">{label}</dt>
              <dd className="text-right text-[#101828]">{value}</dd>
            </div>
          ))}
        </dl>
      </section>

      {/* Blocks */}
      <section className="bg-[#ECEBF2] px-10 pb-14 pt-14">
        <h2 className="font-even-mono text-2xl text-[#101828]">Результаты по блокам</h2>
        <div className="mt-10 flex flex-col gap-8">
          {d.blocks.map((block) => (
            <BlockCard key={block.id} block={block} />
          ))}
        </div>
      </section>

      {/* Pilot recommendation */}
      {d.pilot && (
        <section className="border-t border-[#1a1a1a]/20 bg-[#ECEBF2] px-10 py-14">
          <article className="rounded-[14px] border border-[#e5e7eb] bg-white p-10 shadow-sm">
            <h2 className="font-even-mono text-xl text-[#1a1a1a]">{d.pilot.title}</h2>
            <p className="mt-4 text-lg font-medium text-[#ec5612]">{d.pilot.solutionType}</p>
            <p className="mt-4 text-base leading-7 text-[#1a1a1a]">{d.pilot.summary}</p>
            <ul className="mt-8 space-y-5 border-t border-[#f3f4f6] pt-8">
              {d.pilot.bullets.map((bullet) => (
                <li key={bullet} className="flex gap-4 text-base leading-7 text-[#1a1a1a]">
                  <span className="mt-3 h-1.5 w-1.5 shrink-0 rounded-full bg-[#1a1a1a]" aria-hidden />
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
            {d.pilot.linkHref && (
              <a
                href={d.pilot.linkHref}
                className="mt-8 inline-block border-t border-[#f3f4f6] pt-8 text-base font-medium text-[#ec5612] hover:underline"
              >
                {d.pilot.linkLabel}
              </a>
            )}
          </article>
        </section>
      )}

      {/* Readiness scale */}
      <section className="border-t border-[#1a1a1a]/20 bg-[#ECEBF2] px-10 py-12">
        <h2 className="text-xl font-medium text-[#101828]">Шкала готовности</h2>
        <div className="mt-8 flex flex-col gap-4">
          {d.readinessScale.map((item) => (
            <ReadinessScaleRow key={item.id} item={item} />
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#ECEBF2] px-10 pb-14 pt-14">
        <div
          className="flex flex-col items-center rounded-[14px] px-10 py-10 text-center text-white shadow-lg"
          style={{ background: CTA_GRADIENT }}
        >
          <h3 className="font-even-mono text-3xl leading-9">{d.cta.title}</h3>
          <p className="mt-4 max-w-[360px] text-base text-[#f3e8ff]">{d.cta.subtitle}</p>
          <a
            href={buildDiscussTaskUrl({
              score: d.score,
              maxScore: d.maxScore,
            })}
            className="mt-8 inline-flex h-12 items-center justify-center rounded-[10px] bg-black px-8 text-base font-medium text-white shadow-md hover:bg-black/90"
          >
            {d.cta.buttonLabel}
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative overflow-hidden border-t border-[#f3f4f6] bg-[#1a1a1a] px-10 py-10">
        <div className="relative z-10">
          <img src={ASSETS.logo} alt="Антология" className="h-8 w-auto brightness-0 invert" width={166} height={32} />
          <p className="mt-4 text-sm leading-5 text-[#6a7282]">
            Выгодный и удобный
            <br />
            подбор ИТ‑инструментов
          </p>
          <a href="https://antologia.tech" className="mt-2 inline-block text-sm text-[#4a5565] hover:underline">
            antologia.tech
          </a>
        </div>
        <img
          src={ASSETS.cubesGroup}
          alt=""
          className="pointer-events-none absolute -right-2 bottom-0 h-28 w-auto opacity-90"
          aria-hidden
        />
      </footer>
    </div>
  );
};

export default ChecklistSalesEmail;
